/**
 * 日志配置.
 *
 * @author  yusangeng@outlook.com
 */
/* istanbul ignore file */
import konph from "konph";
import { anything2Level } from "./levelHelper";
export default konph({
    "chivy-level": {
        def: 2,
        fit: anything2Level
    },
    "chivy-modules": {
        def: ["**"],
        fit: konph.helper.fit.strings
    },
    "chivy-driver-flags": {
        def: ["color", "level", "module"],
        fit: konph.helper.fit.strings
    }
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uZmlnLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2NvbmZpZy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7OztHQUlHO0FBRUgsMEJBQTBCO0FBRTFCLE9BQU8sS0FBSyxNQUFNLE9BQU8sQ0FBQztBQUMxQixPQUFPLEVBQUUsY0FBYyxFQUFFLE1BQU0sZUFBZSxDQUFDO0FBUS9DLGVBQWUsS0FBSyxDQUFDO0lBQ25CLGFBQWEsRUFBRTtRQUNiLEdBQUcsRUFBRSxDQUFDO1FBQ04sR0FBRyxFQUFFLGNBQWM7S0FDcEI7SUFFRCxlQUFlLEVBQUU7UUFDZixHQUFHLEVBQUUsQ0FBQyxJQUFJLENBQUM7UUFDWCxHQUFHLEVBQUUsS0FBSyxDQUFDLE1BQU0sQ0FBQyxHQUFHLENBQUMsT0FBTztLQUM5QjtJQUVELG9CQUFvQixFQUFFO1FBQ3BCLEdBQUcsRUFBRSxDQUFDLE9BQU8sRUFBRSxPQUFPLEVBQUUsUUFBUSxDQUFDO1FBQ2pDLEdBQUcsRUFBRSxLQUFLLENBQUMsTUFBTSxDQUFDLEdBQUcsQ0FBQyxPQUFPO0tBQzlCO0NBQ0YsQ0FBQyxDQUFDIn0=